// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import {post,get} from './api/http'
import Vant from 'vant'
import utils from './utils/utils'
import Copy from 'vue-clipboard2'
import { encryptDes, decryptDes } from './crypto/crypto'

import '@/assets/js/rem.js'
import '@/assets/css/normalize.css'
import '@/assets/css/index.css'
import '@/assets/css/jsj_dialog.css'
import 'vant/lib/icon/local.css'
import Es6Promise from 'es6-promise'
import VueScrollTo from 'vue-scrollto';


Es6Promise.polyfill()
import 'babel-polyfill'

Event = new Vue()
Vue.use(Vant)
Vue.use(Copy)
Vue.use(VueScrollTo);
//定义全局变量
Vue.prototype.$post=post
Vue.prototype.$get=get
Vue.prototype.utils = utils
Vue.config.productionTip = false
Vue.prototype.encryptDes = encryptDes
Vue.prototype.decryptDes = decryptDes

// // 解决微信分享出去是首次进入的链接
// router.afterEach(function (to, from, next) {
//     const agent = navigator.userAgent
//     const isiOS = !!agent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
//     // XXX: 修复iOS版微信HTML5 History兼容性问题
//     alert(to.path + location.pathname)
//     if (isiOS && to.path !== location.pathname && utils.browserType()=="wx") {
//         // 此处不可使用location.replace
//         location.assign(to.fullPath)
//     }
// })

new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>',
    created() {

    }
})



// WEBPACK FOOTER //
// ./src/main.js